import Home from '../../components/Home'
import SingIn from '../../components/SingIn'
import SingUp from '../../components/SingUp'
import AssignUser from '../../components/AssignUser'
import Projects from '../../components/Projects'
import LogTimeReport from '../../components/LogTimeReport'
import WorkTimeManagement from '../../pages/WorkTimeManagement'
import BacklogTimeReport from '../../components/BacklogTimeReport'
import KpiReport from '../../components/KpiReport'
import UnitManagement from '../../components/UnitManagement'
import Profile from '../../components/Profile'
import MyProfile from '../../components/MyProfile'
import PasswordReset from '../../components/PasswordReset'
import PasswordUpdate from '../../components/PasswordUpdate'
import Units from '../../components/Units'
import Skills from '../../components/Skills'
import BookingManagment from '../../components/BookingManagment'
import BookingView from '../../components/BookingView'
import Users from '../../components/UsersInfo/Users'
import InfoHr from '../../components/UsersInfo/InfoHr'
import InfoPm from '../../components/UsersInfo/InfoPm'
import Permission from '../../components/Permission'
import NotEstimated from '../../components/NotEstimated'
import store from '@/store'
import FinancesClients from '@pages/FinancesClients'
import FinancesTaxTypes from '@pages/FinancesTaxTypes'
import FinancesExpensesCategories from '../../components/FinancesExpensesCategories'
import FinancesExpenses from '../../components/FinancesExpenses'
import FinancesCompensations from '../../components/FinancesCompensations'
import FinancesPayrolls from '../../components/FinancesPayrolls'
import FinancesPayouts from '@pages/FinancePayoutsPage'
import FinancesPartners from '@pages/FinancePartnersPage'
import FinancesProjectSpecialisation from '@pages/FinancesProjectSpecialisation'
import FinanceClientsBankDetails from '@pages/FinanceClientsBankDetails'
import FinanceBankDetails from '@pages/FinanceBankDetails'
import FinanceBankDetailsCards from '@pages/FinanceBankDetailsCards'
import FinanceBankDetailsContractors from '@pages/FinanceBankDetailsContractors'
import FinanceBankDetailsPartners from '@pages/FinanceBankDetailsPartners'
import FinanceInvoices from '@pages/FinanceInvoices'
import FinanceReports from '@pages/FinanceReports'
import FinanceReportsExpenses from '@pages/FinanceReportsExpenses'
import FinanceReportsPayrolls from '@pages/FinanceReportsPayrolls'
import FinanceReportsProfitAndLoss from '@pages/FinanceReportsProfitAndLoss'
import FinanceReportsProfitAndLossHistorical from '@pages/FinanceReportsProfitAndLossHistorical'
import FinanceReportsProfitAndLossCalculator from '@pages/FinanceReportsProfitAndLossCalculator'
import NotBudget from '@pages/NotBudget'
import FinanceReportsPeopleAndProjects from '@pages/FinanceReportsPeopleAndProjects'
import FinanceSalesReportPage from '@pages/FinanceSalesReportPage'
import FinanceSalesReportHistoricalPage from '../../pages/FinanceSalesReportHistoricalPage'
import FinanceReportsBalances from '@pages/FinanceReportsBalances'
import FinanceSalesChannelsPage from '@pages/FinanceSalesChannelsPage'
import MiscBacklog from '@pages/MiscBacklog'
import SystemOperations from '@pages/SystemOperationsPage'
import FinanceHPReportDetailedPage from '@pages/FinanceHPReportDetailedPage'
import FinanceHPReportOverviewPage from '@pages/FinanceHPReportOverviewPage'
import HoursTrackingReport from '@pages/HoursTrackingPage'
import HolidaysPage from '@pages/HolidaysPage'
import ProfilesWidget from '@pages/ProfilesWidgetPage'
import DefaultLayout from '../../components/DefaultLayout.vue'
// eslint-disable-next-line no-unused-vars
import { permissions } from '@mocks/permissions'
import TelegramPartners from '@pages/notifications/TelegramPartners.vue'
import TelegramContractors from '../../pages/notifications/TelegramContractors.vue'
import TelegramCampaignForPartners from '../../pages/notifications/TelegramCampaignForPartners.vue'
import TelegramCampaignForContractors from '../../pages/notifications/TelegramCampaignForContractors.vue'

function $routerCan (permission) {
  const Permission = store.getters.getPermission
  return Permission.indexOf(permission) !== -1
}

export default [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '/',
        name: 'home',
        component: Home,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-home')) {
            next()
          } else {
            next('/my-profile')
          }
        },
        meta: {
          breadcrumb: 'Home'
        }
      },
      {
        path: '/working-time',
        name: 'working-time',
        component: LogTimeReport,
        meta: {
          breadcrumb: {
            label: 'Working Time',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-log_time_reports')) {
            next()
          }
        }
      },
      {
        path: '/projects',
        name: 'projects',
        component: Projects,
        meta: {
          breadcrumb: {
            label: 'Projects',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-projects')) {
            next()
          }
        }
      },
      {
        path: '/singin',
        name: 'singin',
        component: SingIn
      },
      {
        path: '/singup',
        name: 'singup',
        component: SingUp
      },
      {
        path: '/assignuser',
        name: 'assignUser',
        component: AssignUser,
        beforeEnter: (to, from, next) => {
          if ($routerCan('create-users')) {
            next()
          }
        }
      },

      {
        path: '/working-time-management',
        name: 'working-time-management',
        component: WorkTimeManagement,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.UpdateAllLogTimeReports)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Working Time Management',
            parent: 'home'
          }
        }
      },
      {
        path: '/working-time-hours-tracking',
        name: 'working-time-hours-tracking',
        component: HoursTrackingReport,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-log_time_reports')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Working Time Management',
            parent: 'home'
          }
        }
      },
      {
        path: '/backlog-time-report',
        name: 'backlog-time-report',
        component: BacklogTimeReport,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-backlog_reports')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Backlog Time Report',
            parent: 'home'
          }
        }
      },
      {
        path: '/unit-management',
        name: 'unit-management',
        component: UnitManagement,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-unit_management')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Unit Management',
            parent: 'home'
          }
        }
      },
      {
        path: '/kpi-report',
        name: 'kpi-report',
        component: KpiReport,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-kpi_reports')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Kpi Report',
            parent: 'home'
          }
        }
      },
      {
        path: '/profile/:id/:type',
        name: 'profile',
        component: Profile,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-users')) {
            next()
          }
        }
      },
      {
        path: '/my-profile',
        name: 'my-profile',
        component: MyProfile,
        meta: {
          breadcrumb: {
            label: 'my profile',
            parent: 'home'
          }
        }
      },
      {
        path: '/password-reset',
        name: 'password-reset',
        component: PasswordReset
      },
      {
        path: '/password-update',
        name: 'password-update',
        component: PasswordUpdate
      },
      {
        path: '/units',
        name: 'units',
        component: Units,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-units')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Units',
            parent: 'home'
          }
        }
      },
      {
        path: '/skills',
        name: 'skills',
        component: Skills,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-skills')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Skills',
            parent: 'home'
          }
        }
      },
      {
        path: '/booking-managment',
        name: 'booking-managment',
        component: BookingManagment,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-booking_management')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Booking Managment',
            parent: 'home'
          }
        }
      },
      {
        path: '/booking-view',
        name: 'booking-view',
        component: BookingView,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-booking_view')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Work schedule',
            parent: 'home'
          }
        }
      },
      {
        path: '/users',
        name: 'users',
        component: Users,
        meta: {
          breadcrumb: {
            label: 'Users',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-users')) {
            next()
          }
        }
      },
      {
        path: '/users/info-hr',
        name: 'users-info-hr',
        meta: {
          breadcrumb: {
            label: 'Users info HR',
            parent: 'home'
          }
        },
        component: InfoHr,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-info_from_hr')) {
            next()
          }
        }
      },
      {
        path: '/users/info-pm',
        name: 'users-info-pm',
        meta: {
          breadcrumb: {
            label: 'Users info PM',
            parent: 'home'
          }
        },
        component: InfoPm,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-info_from_pm')) {
            next()
          }
        }
      },
      {
        path: '/permission',
        name: 'permission',
        meta: {
          breadcrumb: {
            label: 'Permissions',
            parent: 'home'
          }
        },
        component: Permission,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-permission')) {
            next()
          }
        }
      },
      {
        path: '/system-operations',
        name: 'system-operations',
        meta: {
          breadcrumb: {
            label: 'System Operations',
            parent: 'home'
          }
        },
        component: SystemOperations,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-system_operations')) {
            next()
          }
        }
      },
      {
        path: '/not-estimated',
        name: 'not-estimated',
        component: NotEstimated,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-not_estimated')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Not Estimated',
            parent: 'home'
          }
        }
      },
      {
        path: '/not-budget',
        name: 'not-budget',
        component: NotBudget,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-not_estimated')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Not Budget',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-clients',
        name: 'finances-clients',
        component: FinancesClients,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-finances_clients')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Clients',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-partners',
        name: 'finances-partners',
        component: FinancesPartners,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-finances_partners')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Clients',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-tax-types',
        name: 'finances-tax-types',
        component: FinancesTaxTypes,
        beforeEnter: (to, from, next) => {
          next()
          if ($routerCan('read_all-finances_tax_types')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Tax types',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-expenses-categories',
        name: 'finances-expenses-categories',
        component: FinancesExpensesCategories,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-finances_expenses_category')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Expenses Categories',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-expenses',
        name: 'finances-expenses',
        component: FinancesExpenses,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_own-finances_expenses')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Expenses',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-compensations',
        name: 'finances-compensations',
        component: FinancesCompensations,
        beforeEnter: (to, from, next) => {
          next()
          // if ($routerCan('read_all-finances_compensations')) {
          //   next()
          // }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Compensations',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-bulk-payouts',
        name: 'finances-bulk-payouts',
        component: FinancesPayrolls,
        beforeEnter: (to, from, next) => {
          next()
          if ($routerCan('read_all-finances_payrolls')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Payrolls',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-payouts',
        name: 'finances-payouts',
        component: FinancesPayouts,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-finances_payouts')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Payouts',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-invoices-project-specialisations',
        name: 'finances-invoices-project-specialisations',
        component: FinancesProjectSpecialisation,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesProjectSpecialisations)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Project Specialisations',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-bank-details-clients',
        name: 'finances-bank-details-clients',
        component: FinanceClientsBankDetails,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesClientBankDetails)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Bank Details Clients',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-bank-details',
        name: 'finances-bank-details',
        component: FinanceBankDetails,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesOwnBankDetails)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Bank Details',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-bank-details-cards',
        name: 'finances-bank-details-cards',
        component: FinanceBankDetailsCards,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesOwnBankDetails)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Bank Details Cards',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-bank-details-contractors',
        name: 'finances-bank-details-contractors',
        component: FinanceBankDetailsContractors,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesContractorBankDetails)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Bank Details Contractors',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-bank-details-partners',
        name: 'finances-bank-details-partners',
        component: FinanceBankDetailsPartners,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesPartnerBankDetails)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Bank Details Partners',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-invoices',
        name: 'finances-invoices',
        component: FinanceInvoices,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesOwnBankDetails)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Invoices',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-sales-report',
        name: 'finances-sales-report',
        component: FinanceSalesReportPage,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesPPReportMoney) ||
              $routerCan(permissions.ReadAllFinancesPPReportProfitability)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Sales Report',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-sales-report-historical',
        name: 'finances-sales-report-historical',
        component: FinanceSalesReportHistoricalPage,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesPPReportMoney) ||
              $routerCan(permissions.ReadAllFinancesPPReportProfitability)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Sales Report historical',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-invoices',
        name: 'finances-reports-invoices',
        component: FinanceReports,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesInvoices)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Invoices',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-expenses',
        name: 'finances-reports-expenses',
        component: FinanceReportsExpenses,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesExpenses)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Expenses',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-payrolls',
        name: 'finances-reports-payrolls',
        component: FinanceReportsPayrolls,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesExpenses)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Payrolls',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-profit-and-loss',
        name: 'finances-reports-profit-and-loss',
        component: FinanceReportsProfitAndLoss,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesReportProfitAndLoss)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Profit And Loss',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-profit-and-loss-historical',
        name: 'finances-reports-profit-and-loss-historical',
        component: FinanceReportsProfitAndLossHistorical,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesReportProfitAndLoss)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Profit And Loss Historical',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-profit-and-loss-calculator',
        name: 'finances-reports-profit-and-loss-calculator',
        component: FinanceReportsProfitAndLossCalculator,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesReportProfitAndLoss)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Profit And Loss Calculator',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-by-people-and-projects',
        name: 'finances-reports-by-people-and-projects',
        component: FinanceReportsPeopleAndProjects,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesReportProfitAndLoss)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Reports - By People And Projects',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-hours-and-payments',
        name: 'finances-reports-hours-and-payments',
        component: FinanceHPReportDetailedPage,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-users')) {
            next()
          }
        }
      },
      {
        path: '/finances-reports-hours-and-payments-overview',
        name: 'finances-reports-hours-and-payments-overview',
        component: FinanceHPReportOverviewPage,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-users')) {
            next()
          }
        }
      },
      {
        path: '/finances-reports-hours-and-payments/:id',
        name: 'h-p-report',
        component: FinanceHPReportDetailedPage,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-users')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Hours and Payments report',
            parent: 'finances-reports-hours-and-payments'
          }
        }
      },
      {
        path: '/finances-reports-balances',
        name: 'finances-reports-balances',
        component: FinanceReportsBalances,
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesReportBalances)) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Balances',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-sales-channels',
        name: 'finances-sales-channels',
        component: FinanceSalesChannelsPage,
        beforeEnter: (to, from, next) => {
          if ($routerCan('read_all-finances_sales_channels')) {
            next()
          }
        },
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Balances',
            parent: 'home'
          }
        }
      },
      {
        path: '/backlog-not-done-and-estimated',
        name: 'backlog-not-done-and-estimated',
        component: MiscBacklog,
        meta: {
          breadcrumb: {
            label: 'Backlog',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesReportProfitAndLoss)) {
            next()
          }
        }
      },
      {
        path: '/holidays',
        name: 'holidays',
        component: HolidaysPage,
        meta: {
          breadcrumb: {
            label: 'Holidays',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => {
          if ($routerCan(permissions.ReadAllFinancesReportProfitAndLoss)) {
            next()
          }
        }
      },
      {
        path: '/available-profiles',
        name: 'available-profiles',
        component: ProfilesWidget
      },
      {
        path: '/notifications/telegram/partners',
        name: 'notifications-telegram-partners',
        component: TelegramPartners
      },
      {
        path: '/notifications/telegram/contractors',
        name: 'notifications-telegram-contractors',
        component: TelegramContractors
      },
      {
        path: '/notifications/telegram/campaigns-for-partners',
        name: 'notifications-telegram-campaigns-for-partners',
        component: TelegramCampaignForPartners
      },
      {
        path: '/notifications/telegram/campaigns-for-contractors',
        name: 'notifications-telegram-campaigns-for-contractors',
        component: TelegramCampaignForContractors
      }
    ]
  }
]
